export default {"src":"/_next/static/media/ArcTopLeftBrown.39810620.svg","height":8,"width":7,"blurWidth":0,"blurHeight":0};